export default __webpack_public_path__ + "static/28-5d7ea8d213c467f4dbcb8889e7e661b7.webp";